/**
 * 渠道包上传弹窗第一步。选择文件/URL表单
 */
import React, { useState } from 'react'
import AlertTips from 'pureComponents/AlertTips'
import DialogAppInfo from 'pureComponents/DialogAppInfo'
import DialogPkgNameInput from 'pureComponents/DialogPkgNameInput'
import DialogUploadContent from 'pureComponents/DialogUploadContent'
import DialogUploadTypeRadioGroup from 'pureComponents/DialogUploadTypeRadioGroup'
import DialogUploadPlatformCheckboxGroup from 'pureComponents/DialogUploadPlatformCheckboxGroup'
import DialogTips from 'pureComponents/DialogTips'
import useUploadSetting from './hooks/useUploadSetting'
import { SINGLE_UPLOAD_RADIO, MULTI_UPLOAD_RADIO, APK_PLATFORM_RADIO } from './constants'
import { PLATFORM_VALUE } from 'biz-components/ChannelPkgList/constants'

const UploadSetting = props => {
    const {
        formError,
        formData,
        handleFormDataChange,
        handleUploadTypeChange,
        genTips,
        uploadType,
        isSingle,
    } = useUploadSetting(props)
    const { appInfo = {}, dialogType = 'singleReplace' } = props

    // 这里选择位数的 checkbox 只是给用户提示用的，前后端都不会使用这个用户选择的值
    const [platforms, setPlatform] = useState([PLATFORM_VALUE.Bit64])
    const platformChange = v => {
        setPlatform(v)
    }

    return (
        <div>
            {formError.files || formError.urlFile ? (
                <div className="track-body-item">
                    <AlertTips type="error" icon="warn">
                        {formError.files || formError.urlFile}
                    </AlertTips>
                </div>
            ) : null}
            <div className="track-body-item">
                <DialogAppInfo label="APP名称：" name={appInfo.name || ''} desc={`（应用ID：${appInfo.openAppId}）`} />
            </div>
            {isSingle(dialogType) ? (
                <DialogPkgNameInput
                    value={formData.channelName}
                    onChange={val => handleFormDataChange('channelName', val)}
                    error={formError.channelName}
                />
            ) : null}
            <DialogUploadPlatformCheckboxGroup data={APK_PLATFORM_RADIO} value={platforms} onChange={platformChange} />
            <DialogUploadTypeRadioGroup
                data={isSingle(dialogType) ? SINGLE_UPLOAD_RADIO : MULTI_UPLOAD_RADIO}
                value={uploadType}
                onChange={handleUploadTypeChange}
            />
            <DialogUploadContent
                formData={formData}
                formError={formError}
                uploadType={uploadType}
                dialogType={dialogType}
                onFormDataChange={handleFormDataChange}
            />
            <DialogTips data={genTips(dialogType, uploadType)} />
        </div>
    )
}

export default UploadSetting
